module.exports = __webpack_public_path__ + "static/media/04.c1ec14e8.png";